<template>
  <div>
    <component
      v-for="(fila, i) in filas"
      :is="fila.component"
      :key="i"
      :lines="fila.lines"
      :polygons="fila.polygons"
      :line-selected.sync="fila.lineSelected"
      :polygon-selected.sync="fila.polygonSelected"
      :color-selected.sync="fila.colorSelected"
      :active-key="activeBtn"
      @draw="drawGeometry(fila, $event)"
      class="px-0"
    />
  </div>
</template>

<script>
import SymbologyLinePolygonRow from './SymbologyLinePolygonRow.vue'
import SymbologyColorLineRow from './SymbologyColorLineRow.vue'
import { mapGetters } from 'vuex'
import { getCIMSymbol } from '@/helpers/GraphicsSimbology'

export default {
  components: { SymbologyLinePolygonRow, SymbologyColorLineRow },

  data() {
    return {
      activeBtn: null
    }
  },

  computed: {
    ...mapGetters('map', [
      'symbologyLines',
      'symbologyLinesEscenario',
      'symbologyLinesSITAC',
      'symbologyPolygons'
    ]),

    filas() {
      return [
        {
          component: SymbologyLinePolygonRow,
          lines: this.symbologyLines,
          polygons: this.symbologyPolygons,
          lineSelected: this.symbologyLines[0] ?? null,
          polygonSelected: this.symbologyPolygons[0] ?? null,
          colorSelected: { rgba: { r: 233, g: 16, b: 16, a: 0.7 } }
        },
        {
          component: SymbologyColorLineRow,
          lines: this.symbologyLinesEscenario,
          polygons: [],
          lineSelected: this.symbologyLinesEscenario[0] ?? null,
          polygonSelected: null,
          colorSelected: { rgba: { r: 16, g: 233, b: 16, a: 0.7 } }
        },
        {
          component: SymbologyColorLineRow,
          lines: this.symbologyLinesSITAC,
          polygons: [],
          lineSelected: this.symbologyLinesSITAC[0] ?? null,
          polygonSelected: null,
          colorSelected: { rgba: { r: 16, g: 16, b: 233, a: 0.7 } }
        }
      ]
    }
  },

  methods: {
    drawGeometry(fila, type) {
      this.activeBtn = `${type}Button`

      // Tomamos la línea y el color de la fila correspondiente
      const activeLine = fila.lineSelected
      const activePolygon = fila.polygonSelected
      const color = this.rgbaToEsriColor(fila.colorSelected.rgba)

      const cimDefinicion =
        type === 'polyline' && activeLine?.style
          ? getCIMSymbol(activeLine.style, color)
          : type === 'polygon' && activePolygon?.style
            ? getCIMSymbol(activePolygon.style, color)
            : null

      const event = {
        function: type,
        color,
        type_line: activeLine?.style ?? null,
        type_polygon: activePolygon?.style ?? null,
        labelPolyline: activeLine ?? null,
        labelPolygon: activePolygon ?? null,
        lineSrc: activeLine?.src ?? null,
        lineImagePath: activeLine ? `simbologia_v3/${activeLine.src}` : null,
        cimSymbol: cimDefinicion
      }

      this.$emit('paint', event)
    },

    rgbaToEsriColor(rgba) {
      return [rgba.r, rgba.g, rgba.b, Math.round((rgba.a ?? 1) * 255)]
    }
  }
}
</script>
